<template>
  <div :class="['row', componentSubType]">
    <div v-for="(column, i1) in attributes.value" :key="i1" class="col" :style="{width: (100 / attributes.value.length - 2) + '%'}">
      <div v-for="(col, i2) in column.column" :key="i2" class="col-item">
        <component v-for="(item, key) in col" :key="key" :is="mapComponentsKey(key)" :attributes="mapComponentsValue(item, key)"></component>
      </div>
    </div>
  </div>
</template>

<script>
import paragraph from '../Paragraph'
import subtitle from '../Subtitle'

export default {
  props: ['attributes'],
  components: {
    subtitle,
    paragraph
  },
  data () {
    return {
      componentSubType: this.attributes.type.split('Grid')[1] || '0'
    }
  },
  methods: {
    mapComponentsKey (key) {
      switch (key) {
        case 'p':
          return 'paragraph'
        case 'h4':
          return 'subtitle'
        default:
          return ''
      }
    },
    mapComponentsValue (item, key) {
      if (['h4', 'h3', 'h2'].includes(key)) {
        return {
          mode: key,
          value: item
        }
      }
      return {
        value: item
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.row {
  .col {
    display: inline-block;
    vertical-align: top;
    @media (max-width: 512px) {
      width: 100% !important;
    }
    &:last-child {
      padding-right: 0 !important;
      margin-right: 0 !important;
    }
    .col-item {
      padding-bottom: 30px;
    }
  }
}
</style>
